import { Label } from "../../../../../../../../library/label";
import { getIcon } from "../../../../../../../../utils/get-icon";
import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  AccordionTitle,
  InnerAccordionHeader,
} from "../styled";
import { FieldWrapper, Input } from "./styled";
import ColorSelect from "../../../../../../../../library/color-select";
import { useSettings } from "../../../../context";

const BackgroundSettings = () => {
  const { updateBackgroundSettings, getSelectedItemSettings } = useSettings();

  const currentSettings = getSelectedItemSettings();

  const handleBackgroundColorChange = (colorResult: any) => {
    updateBackgroundSettings({ color: colorResult });
  };

  const onResetBackgroundColor = () => {
    updateBackgroundSettings({ color: "transparent" });
  };

  const handleBackgroundRadiusChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const size = parseInt(e.target.value, 10);
    if (!isNaN(size)) {
      updateBackgroundSettings({ radius: size });
    }
  };

  return (
    <AccordionItem key="5" eventKey="5">
      <AccordionHeader>
        <InnerAccordionHeader>
          <AccordionTitle>{getIcon("")} Bakgrunn</AccordionTitle>
        </InnerAccordionHeader>
      </AccordionHeader>
      <AccordionBody>
        <FieldWrapper>
          <Label>Farge</Label>
          <ColorSelect
            color={currentSettings.configuration.background.color}
            onChange={handleBackgroundColorChange}
            onReset={onResetBackgroundColor}
          />
        </FieldWrapper>
        <FieldWrapper>
          <Label>Radius</Label>
          <Input
            type="number"
            min={1}
            max={100}
            name="fontSize"
            onChange={handleBackgroundRadiusChange}
            value={currentSettings.configuration.background.radius}
          />
        </FieldWrapper>
      </AccordionBody>
    </AccordionItem>
  );
};

export default BackgroundSettings;
